import { BlueprintInfo, CreateBlueprintTemplate } from "../api/Blueprints";
import { buildEmptyMockPromise, buildMockPromise } from "../api/helpers";

export async function blueprintCreateMock(
  blueprintInfo: BlueprintInfo
): Promise<BlueprintInfo> {
  return await buildMockPromise<BlueprintInfo>({
    ...blueprintInfo,
    external_id: "bluef1f-4408-44ec-9fa4-db4b17fdbf60",
    name: "Express Check",
    workflow_config_uuid: "work1f-4408-44ec-9fa4-db4b17fdbf60",
  });
}

export async function createBlueprintMock(
  input: CreateBlueprintTemplate
): Promise<string> {
  return await buildMockPromise("OK", 1000);
}

export async function userDeleteMock(blueprint_uuid: string): Promise<void> {
  return await buildEmptyMockPromise();
}

export async function userUpdateMock(
  blueprintInfo: BlueprintInfo
): Promise<void> {
  return await buildEmptyMockPromise();
}
